import { Button, IconButton, TextField, Typography } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CustomCard from "../../../components/card";
import {
  wrapperHeader,
  wrapperId,
  wrapperMain,
  wrapperNoData,
  wrapperSearch,
} from "./history.style";
import { useMutation } from "@tanstack/react-query";
import { exchangeInfoService } from "../../../services/exchangeInfo";
import { FC, useEffect, useState } from "react";
import SwapDetails from "../swapDetails";
import useAppSelector from "../../../hooks/useSelector";
import { store } from "../../../redux/store";
import { setToast } from "../../../redux/slices/toastSlice";
import Grid from "@mui/material/Grid2";
import { AxiosError } from "axios";

interface IProps {
  setSwitch: (arg0: number) => void;
  setConfirm: (arg0: boolean) => void;
  setShowWallet: (arg0: boolean) => void;
  swapDetail: boolean;
  setSwapDetail: (swapDetail: boolean) => void;
  historyRequestId: string;
  setHistoryRequestId: (historyRequestId: string) => void;
  setLoading: (arg0: boolean) => void;
  setActive: (arg0: number) => void;
}

const History: FC<IProps> = ({
  setSwitch,
  setConfirm,
  setShowWallet,
  swapDetail,
  setSwapDetail,
  historyRequestId,
  setHistoryRequestId,
  setLoading,
  setActive,
}) => {
  const [exchangeId, setExchangeId] = useState("");
  const [exchangeInfo, setExchangeInfo] = useState([]);
  const [trackLoading, setTrackLoading] = useState(false);

  const historyListData = useAppSelector((state) => state.history.historyList);

  const exchangeInfoQuery = useMutation({
    mutationFn: exchangeInfoService,
  });

  const handleExchangeId = (e: React.ChangeEvent<HTMLInputElement>) => {
    setExchangeId(e.target.value);
  };

  const handleBack = () => {
    setSwitch(1);
  };

  const handleSwap = (id: string) => {
    setTrackLoading(true);
    setHistoryRequestId(id);
    exchangeInfoQuery.mutate(id, {
      onSuccess(data) {
        setTrackLoading(false);
        setSwapDetail(true);
        setExchangeInfo(data?.data);
      },
      onError(error) {
        setTrackLoading(false);
        const axiosError = error as AxiosError;
        if (axiosError.response?.status === 403) {
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
        store.dispatch(
          setToast({
            open: true,
            type: "error",
            text: "The exchange ID was not found.",
          })
        );
      },
    });
  };

  useEffect(() => {
    if (historyRequestId && swapDetail) {
      const swapInterval = setInterval(() => {
        handleSwap(historyRequestId);
      }, 30000);
      return () => clearInterval(swapInterval);
    }
  }, [historyRequestId, swapDetail, exchangeId]);

  return (
    <>
      {!swapDetail ? (
        <Grid
          sx={wrapperMain}
          className="animate__animated animate__fadeIn fix_layout"
        >
          <CustomCard>
            <Grid sx={wrapperHeader} mt={2} mb={3}>
              <IconButton onClick={handleBack}>
                <ArrowBackIosIcon />
              </IconButton>
              <Typography variant="h5">History</Typography>
            </Grid>
            <Grid sx={wrapperSearch}>
              <TextField
                placeholder="Search Transaction"
                value={exchangeId}
                onChange={handleExchangeId}
                required
              />
              <Button
                disabled={trackLoading}
                variant="contained"
                onClick={() => handleSwap(exchangeId)}
              >
                {trackLoading ? (
                  <>
                    <img
                      className="loading"
                      src="/assets/images/loading.svg"
                      alt="flashift"
                    />
                    Waiting...
                  </>
                ) : (
                  "Track Your Swap"
                )}
              </Button>
            </Grid>
            {historyListData?.length > 0 ? (
              <Grid
                my={2}
                pt={2}
                style={{
                  borderTop: "1px solid rgba(255,255,255,0.3)",
                  height: "390px",
                  overflowY: "scroll",
                }}
              >
                {[...historyListData]
                  .slice()
                  .reverse()
                  .map((item, index) => (
                    <Grid
                      key={index}
                      sx={wrapperId}
                      mb={1}
                      onClick={() => handleSwap(item)}
                    >
                      <span>{historyListData.length - index}</span>
                      <span>{item}</span>
                    </Grid>
                  ))}
              </Grid>
            ) : (
              <Grid sx={wrapperNoData}>
                <Typography variant="h6">No transactions</Typography>
                <Typography my={1}>
                  Your transaction history is stored locally and will appear
                  here after you start a swap.
                </Typography>
              </Grid>
            )}
          </CustomCard>
        </Grid>
      ) : (
        <SwapDetails
          setSwapDetail={setSwapDetail}
          setConfirm={setConfirm}
          setShowWallet={setShowWallet}
          exchangeInfo={exchangeInfo}
          historyRequestId={historyRequestId}
          setSwitch={setSwitch}
          setLoading={setLoading}
          setActive={setActive}
        />
      )}
    </>
  );
};

export default History;
